"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
// @ts-nocheck
var draft_js_1 = require("draft-js");
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var inline_toolbar_utils_1 = require("./inline-toolbar-utils");
var InlineToolbar = function (_a) {
    var editorState = _a.editorState, setEditorState = _a.setEditorState, selectionRect = _a.selectionRect, showAddLinkModal = _a.showAddLinkModal, visible = _a.visible, onChange = _a.onChange;
    var rect = inline_toolbar_utils_1.Rect.rect;
    var _b = react_1.useState(false), isAlignmentDropdownOpen = _b[0], setAlignmentDropdownOpen = _b[1];
    var _c = react_1.useState(false), isFormatDropdownOpen = _c[0], setFormatDropdownOpen = _c[1];
    var _d = react_1.useState(false), isMoreDropdownOpen = _d[0], setMoreDropdownOpen = _d[1];
    var openClassName = "editor-view__inlinetoolbar--columns--open";
    var closedClassName = "editor-view__inlinetoolbar--columns--closed";
    var alignment = isAlignmentDropdownOpen ? openClassName : closedClassName;
    var format = isFormatDropdownOpen ? openClassName : closedClassName;
    var more = isMoreDropdownOpen ? openClassName : closedClassName;
    var actions = inline_toolbar_utils_1.generateActions(alignment, isAlignmentDropdownOpen, setAlignmentDropdownOpen);
    var handleAction = function (_a) {
        var action = _a.action;
        if (action.type === inline_toolbar_utils_1.ACTION_TYPE.MODAL) {
            showAddLinkModal(true);
        }
        else {
            showAddLinkModal(false);
        }
        if (action.type === inline_toolbar_utils_1.ACTION_TYPE.ATOMIC) {
            var contentState = editorState.getCurrentContent();
            var contentStateWithEntity = contentState.createEntity(inline_toolbar_utils_1.ENTITY.HORIZONTAL_RULE.type, inline_toolbar_utils_1.ENTITY.HORIZONTAL_RULE.mutability, {});
            var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
            var newState = draft_js_1.AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, " ");
            setEditorState(newState);
        }
        if (action.type === inline_toolbar_utils_1.ACTION_TYPE.INLINE) {
            var newState = draft_js_1.RichUtils.toggleInlineStyle(editorState, action.style);
            setEditorState(newState);
            onChange(newState);
        }
        if (action.type === inline_toolbar_utils_1.ACTION_TYPE.BLOCK) {
            var newState = draft_js_1.RichUtils.toggleBlockType(editorState, action.style);
            setEditorState(newState);
            onChange(newState);
        }
    };
    return (react_1["default"].createElement("div", { className: visible
            ? "editor-view__inlinetoolbar"
            : "editor-view__inlinetoolbar editor-view__hidden", style: {
            position: "sticky",
            display: "inline-block",
            top: inline_toolbar_utils_1.getInlineToolbarTopPosition(selectionRect),
            left: inline_toolbar_utils_1.getInlineToolbarLeftPosition(rect, selectionRect)
        } },
        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--items" },
            react_1["default"].createElement("div", { className: "row" }, inline_toolbar_utils_1.generateToolbar(actions, editorState, handleAction)),
            react_1["default"].createElement("div", { className: format, onMouseDown: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    setFormatDropdownOpen(!isFormatDropdownOpen);
                }, role: "button" },
                react_1["default"].createElement("span", null, inline_toolbar_utils_1.getCurrentBlockTypeLabel(editorState)),
                isFormatDropdownOpen && (react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu" },
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button" },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text", role: "button", onMouseDown: function (e) {
                                return handleAction({
                                    e: e,
                                    action: { type: inline_toolbar_utils_1.ACTION_TYPE.BLOCK, style: "unstyled" }
                                });
                            } }, "Paragraph")),
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button" },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text", role: "button", onMouseDown: function (e) {
                                return handleAction({
                                    e: e,
                                    action: { type: inline_toolbar_utils_1.ACTION_TYPE.BLOCK, style: "header-one" }
                                });
                            } }, "Heading 1")),
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button", onMouseDown: function (e) {
                            return handleAction({
                                e: e,
                                action: { type: inline_toolbar_utils_1.ACTION_TYPE.BLOCK, style: "header-two" }
                            });
                        } },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text" }, "Heading 2")),
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button", onMouseDown: function (e) {
                            return handleAction({
                                e: e,
                                action: { type: inline_toolbar_utils_1.ACTION_TYPE.BLOCK, style: "header-three" }
                            });
                        } },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text" }, "Heading 3")),
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button", onMouseDown: function (e) {
                            return handleAction({
                                e: e,
                                action: { type: inline_toolbar_utils_1.ACTION_TYPE.BLOCK, style: "header-four" }
                            });
                        } },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text" }, "Heading 4")),
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button", onMouseDown: function (e) {
                            return handleAction({
                                e: e,
                                action: { type: inline_toolbar_utils_1.ACTION_TYPE.BLOCK, style: "header-five" }
                            });
                        } },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text" }, "Heading 5")),
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button", onMouseDown: function (e) {
                            return handleAction({
                                e: e,
                                action: { type: inline_toolbar_utils_1.ACTION_TYPE.BLOCK, style: "header-six" }
                            });
                        } },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text" }, "Heading 6"))))),
            react_1["default"].createElement("div", { className: more, onMouseDown: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    setMoreDropdownOpen(!isMoreDropdownOpen);
                }, role: "button" },
                react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--more" },
                    react_1["default"].createElement("span", null,
                        react_1["default"].createElement("i", { className: "fas fa-ellipsis-h" }))),
                isMoreDropdownOpen && (react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu" },
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button", onMouseDown: function (e) {
                            return handleAction({
                                e: e,
                                action: { type: inline_toolbar_utils_1.ACTION_TYPE.INLINE, style: "CODE" }
                            });
                        } },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text" }, "Monospace")),
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button", onMouseDown: function (e) {
                            return handleAction({
                                e: e,
                                action: {
                                    type: inline_toolbar_utils_1.ACTION_TYPE.INLINE,
                                    style: "STRIKETHROUGH"
                                }
                            });
                        } },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text" }, "Strikethrough")),
                    react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--item", role: "button", onMouseDown: function (e) {
                            return handleAction({
                                e: e,
                                action: { type: inline_toolbar_utils_1.ACTION_TYPE.ATOMIC, style: "HR" }
                            });
                        } },
                        react_1["default"].createElement("div", { className: "editor-view__inlinetoolbar--submenu--text" }, "HR"))))))));
};
InlineToolbar.propTypes = {
    editorState: prop_types_1["default"].object.isRequired,
    selectionRect: prop_types_1["default"].object.isRequired,
    setEditorState: prop_types_1["default"].func.isRequired,
    showAddLinkModal: prop_types_1["default"].func.isRequired,
    onChange: prop_types_1["default"].func.isRequired,
    visible: prop_types_1["default"].bool.isRequired
};
exports["default"] = InlineToolbar;
